import { render, staticRenderFns } from "./QuotationRiskForm2.vue?vue&type=template&id=7c128e07"
import script from "./QuotationRiskForm2.vue?vue&type=script&lang=js"
export * from "./QuotationRiskForm2.vue?vue&type=script&lang=js"
import style0 from "./QuotationRiskForm2.vue?vue&type=style&index=0&id=7c128e07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports